import { Colour, TileType, Tile } from "../types/tile";

export function ColourToString(colour: Colour): string {
    switch (colour) {
        case Colour.BLACK:
            return "black";
        case Colour.BLUE:
            return "blue";
        case Colour.ORANGE:
            return "orange";
        case Colour.RED:
            return "red";
        default:
            return "error";
    }
}

// It's still numerical, so TileType.ONE => "1"
export function TileTypeToString(tileType: TileType): string {
    switch (tileType) {
        case TileType.JOKER:
            return "🤪";
        case TileType.ONE:
            return "1";
        case TileType.TWO:
            return "2";
        case TileType.THREE:
            return "3";
        case TileType.FOUR:
            return "4";
        case TileType.FIVE:
            return "5";
        case TileType.SIX:
            return "6";
        case TileType.SEVEN:
            return "7";
        case TileType.EIGHT:
            return "8";
        case TileType.NINE:
            return "9";
        case TileType.TEN:
            return "10";
        case TileType.ELEVEN:
            return "11";
        case TileType.TWELVE:
            return "12";
        case TileType.THIRTEEN:
            return "13";
        default:
            return "error";
    }
}

export function TileToReadableString(tile: Tile): string {
    const colourStr = ColourToString(tile.Colour);
    const tileTypeStr = TileTypeToString(tile.TileType);
    return `${colourStr} ${tileTypeStr}`;
}

export function* AllColours(): Generator<Colour, void, unknown> {
    for (let colour = 0; colour < 4; colour++) yield colour as Colour;
}

export function* AllTileTypes(): Generator<TileType, void, unknown> {
    for (let tileType = 0; tileType < 14; tileType++)
        yield tileType as TileType;
}

export function* AllValidTiles(): Generator<Tile, void, unknown> {
    for (const colour of AllColours()) {
        for (const tileType of AllTileTypes()) {
            const tile: Tile = { Colour: colour, TileType: tileType };
            if (!isValidTile(tile)) continue;
            yield tile;
        }
    }
}

function isValidTile(tile: Tile): boolean {
    const tileColour = tile.Colour;
    const tileType = tile.TileType;

    if (tileType === TileType.JOKER)
        return tileColour === Colour.RED || tileColour === Colour.BLACK;
    return true;
}
